import React from 'react';
import styles from './PaymentInvoice.module.css';

const KraveinToggle = ({ showKravein, onChange }) => (
  <div className={styles.toggleWrap}>
    <label className={styles.toggle}>
      <input type="checkbox" checked={showKravein} onChange={onChange} />
      <span className={styles.toggleSlider} />
    </label>
    <div className={styles.toggleText}>
      <div className={styles.toggleTitle}>Show KRAVEiN Charges</div>
      <div className={styles.toggleDesc}>
        When ON: displays Delivery Fee, Credit Card Fee, Service Charges and
        Total Amount charged to customer. Default: OFF (venue view only shows
        Sale Value columns)
      </div>
    </div>
    <span
      className={`tag ${styles.tag} ${showKravein ? styles.tAm : styles.tGy}`}
    >
      KRAVEiN Charges: {showKravein ? 'ON' : 'OFF'}
    </span>
  </div>
);

export default KraveinToggle;
